import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './filter-builder.component.scss';
import * as $ from 'jquery';
var FilterBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(FilterBuilder, _super);
    function FilterBuilder(element) {
        return _super.call(this, element) || this;
    }
    FilterBuilder.prototype.init = function () {
        var _this = this;
        this.form = this.element.querySelector('#filter-builder-form');
        this.selectButtons = Array.from(this.element.querySelectorAll('.filter-builder__form-field--select-button'));
        this.selectItems = Array.from(this.element.querySelectorAll('.filter-builder__form-field--select-box-item'));
        this.searchBars = Array.from(this.element.querySelectorAll('.js-search-bar'));
        this.clearButton = this.element.querySelector('.js-clear-filters');
        this.clearButtonInput = this.element.querySelector('.filter-builder__form-field--searchbuttonclear');
        this.multpleSelected = Array.from(this.element.querySelectorAll('.filter-builder__form-field--select-box-item input'));
        this.multpleSelectedLabel = this.element.querySelector('.js-checkbox-multiple-only');
        this.checkboxesDesktop = Array.from(this.element.querySelectorAll('.filter-builder__form-field--checkboxlabel input'));
        setTimeout(function () {
            _this.removeDropDownItem();
            _this.changeButtonText();
        }, 500);
    };
    FilterBuilder.prototype.bindEvents = function () {
        var _this = this;
        if (this.form) {
            this.form.addEventListener('click', function (event) {
                var component = event.target;
                if (component.classList.contains('title')) {
                    _this.closeAllSelects();
                }
                if (component.classList.contains('col-12')) {
                    _this.closeAllSelects();
                }
                if (component.classList.contains('filter-builder__form-field--hr')) {
                    _this.closeAllSelects();
                }
            });
        }
        if (this.selectButtons) {
            this.selectButtons.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                // if(element.classList.contains('filter-builder__form-field--select-button__active')) {
                // 	element.classList.remove('filter-builder__form-field--select-button__active');
                // }else{
                // 	element.classList.add('filter-builder__form-field--select-button__active');
                // }
                var parent = element.closest('.filter-builder__form-field--container');
                var box = parent.querySelector('.filter-builder__form-field--select-box');
                if (box.classList.contains('filter-builder__form-field--select-box-active')) {
                    box.classList.remove('filter-builder__form-field--select-box-active');
                    element.classList.remove('filter-builder__form-field--select-button__active');
                }
                else {
                    _this.closeAllSelects();
                    box.classList.add('filter-builder__form-field--select-box-active');
                    element.classList.add('filter-builder__form-field--select-button__active');
                }
            }); });
        }
        if (this.selectItems) {
            this.selectItems.map(function (item) { return item.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var value = element.getAttribute('data-value');
                var name = element.getAttribute('data-name');
                var parent = element.closest('.filter-builder__form-field--container');
                var button = parent.querySelector('.filter-builder__form-field--select-button');
                var box = parent.querySelector('.filter-builder__form-field--select-box');
                if (!button.classList.contains('js-checkbox-multiple-only')) {
                    var checkboxes = Array.from(box.querySelectorAll('input'));
                    if (checkboxes.length > 0) {
                        var amountChecked_1 = 0;
                        var checkedLabels_1 = [];
                        checkboxes.map(function (checkbox) {
                            if (checkbox.checked) {
                                checkedLabels_1.push(checkbox.getAttribute('data-value'));
                                amountChecked_1++;
                            }
                        });
                        if (amountChecked_1 > 1) {
                            button.innerHTML = amountChecked_1 + ' Selected';
                        }
                        else if (amountChecked_1 == 0) {
                            button.innerHTML = 'Please select';
                        }
                        else {
                            if (checkedLabels_1[0]) {
                                button.innerHTML = checkedLabels_1[0];
                            }
                        }
                    }
                    else {
                        console.log('No Checkboxes');
                        button.innerHTML = name;
                    }
                }
                box.classList.toggle('filter-builder__form-field--select-box-active');
                button.classList.toggle('filter-builder__form-field--select-button__active');
            }); });
        }
        if (this.clearButton) {
            this.clearButton.addEventListener('click', function (event) {
                _this.selectButtons.map(function (button) {
                    button.innerHTML = 'Please select';
                });
                _this.form.reset();
            });
        }
        $('body').on('click', 'a#resetSearch', function (event) {
            _this.selectButtons.map(function (button) {
                button.innerHTML = 'Please select';
            });
            _this.form.reset();
        });
        if (this.clearButtonInput) {
            this.clearButtonInput.addEventListener('click', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element.target;
                }
                var parent = element.closest('.filter-builder__form-field--container');
                var searchButton = parent.querySelector('.filter-builder__form-field--searchbutton');
                searchButton.classList.remove('active');
                element.classList.add('d-none');
                var inputs = Array.from(_this.form.querySelectorAll('input'));
                inputs.map(function (input) {
                    input.value = '';
                });
            });
        }
        if (this.multpleSelected) {
            this.multpleSelected.map(function (item) { return item.addEventListener('click', function (event) {
                var amountChecked = 0;
                var checkedLabels = [];
                _this.multpleSelected.map(function (checkbox) {
                    if (checkbox.checked) {
                        checkedLabels.push(checkbox.getAttribute('data-value'));
                        amountChecked++;
                    }
                });
                if (_this.multpleSelectedLabel) {
                    if (amountChecked > 1) {
                        _this.multpleSelectedLabel.innerHTML = amountChecked + ' Selected';
                    }
                    else if (amountChecked == 0) {
                        _this.multpleSelectedLabel.innerHTML = 'Please select';
                    }
                    else {
                        if (checkedLabels[0]) {
                            _this.multpleSelectedLabel.innerHTML = checkedLabels[0];
                        }
                    }
                }
            }); });
        }
        if (this.checkboxesDesktop) {
            this.checkboxesDesktop.map(function (item) { return item.addEventListener('click', function (event) {
                _this.closeAllSelects();
            }); });
        }
        if (this.searchBars) {
            this.searchBars.map(function (searchbar) { return searchbar.addEventListener('focus', function (event) {
                _this.closeAllSelects();
            }); });
            this.searchBars.map(function (searchbar) { return searchbar.addEventListener('keyup', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var parent = element.closest('.filter-builder__form-field--container');
                var clearButton = parent.querySelector('.filter-builder__form-field--searchbuttonclear');
                var searchButton = parent.querySelector('.filter-builder__form-field--searchbutton');
                if (element.value.length > 0) {
                    clearButton.classList.remove('d-none');
                    searchButton.classList.add('active');
                }
                else {
                    clearButton.classList.add('d-none');
                    searchButton.classList.remove('active');
                }
            }); });
            this.searchBars.map(function (searchbar) { return searchbar.addEventListener('paste', function (event) {
                var element;
                if (event.currentTarget) {
                    element = event.currentTarget;
                }
                else {
                    element = event.target;
                }
                var parent = element.closest('.filter-builder__form-field--container');
                var clearButton = parent.querySelector('.filter-builder__form-field--searchbuttonclear');
                var searchButton = parent.querySelector('.filter-builder__form-field--searchbutton');
                setTimeout(function () {
                    if (element.value.length > 0) {
                        clearButton.classList.remove('d-none');
                        searchButton.classList.add('active');
                    }
                    else {
                        clearButton.classList.add('d-none');
                        searchButton.classList.remove('active');
                    }
                }, 200);
            }); });
        }
    };
    FilterBuilder.prototype.removeDropDownItem = function () {
        if (this.selectItems) {
            this.selectItems.map(function (item) {
                if (item.classList.contains('dropdown-item')) {
                    item.classList.remove('dropdown--item');
                }
            });
        }
    };
    FilterBuilder.prototype.changeButtonText = function () {
        if (this.selectButtons) {
            this.selectButtons.map(function (button) {
                button.innerHTML = 'Please select';
            });
        }
    };
    FilterBuilder.prototype.closeAllSelects = function () {
        var allSelectButtons = Array.from(document.querySelectorAll('.filter-builder__form-field--select-button'));
        allSelectButtons.map(function (item) {
            var element = item;
            var parent = element.closest('.filter-builder__form-field--container');
            var box = parent.querySelector('.filter-builder__form-field--select-box');
            element.classList.remove('filter-builder__form-field--select-button__active');
            box.classList.remove('filter-builder__form-field--select-box-active');
        });
    };
    return FilterBuilder;
}(Base));
export { FilterBuilder };



//////////////////
// WEBPACK FOOTER
// ./components/filter-builder/filter-builder.component.ts
// module id = 289
// module chunks = 0